import { StopSearch } from "@catchy/ui";
import useLocalStorage from "hooks/useLocalStorage";
import { getMapCenterDefault } from "@/lib/regions/client";
export default function Search(props) {
  const {
    center
  } = getMapCenterDefault();
  return <StopSearch {...props} useLocalStorage={useLocalStorage} favouritesStorageKey="favourites" fallbackLocation={{
    latitude: center.lat,
    longitude: center.lng
  }} searchDescriptions={false} showStopIdentifier={(_stop, type) => type === "bus"} placeholder={props.type === "bus" ? "Search bus stops" : "Search train stations"} />;
}